export default __webpack_public_path__ + "static/media/thand2.c6be342a.png";